module.exports = __webpack_public_path__ + "static/media/ios-color-wand.af5b964f.svg";